var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-background-white is-border"},[_c('lot-form',{attrs:{"source-loading":_vm.loading,"source-lot-program":_vm.lotProgram},on:{"submit":_vm.createLot}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }